import { Customer2Qualification } from '../../mdqx-graphql-types';

export class Customer2QualificationEntity {
    public static readonly GqlFields = 'customerId qualificationId';

    public CustomerId: number;
    public QualificationId: number;

    constructor(customer2QualificationType?: Customer2Qualification | null) {
        if (
            customer2QualificationType &&
            customer2QualificationType.customerId != null &&
            customer2QualificationType.qualificationId != null
        ) {
            this.CustomerId = customer2QualificationType.customerId;
            this.QualificationId = customer2QualificationType.qualificationId;
        } else {
            console.error('received broken Customer2QualificationType', customer2QualificationType);
            throw Error();
        }
    }
}
